import { defineMessages } from 'react-intl';

export default defineMessages({
    lossCause : {
        id: "policychange.common.views.common.premier-risk-analysis.Loss Cause",
        defaultMessage: "Loss Cause"
    },
    riskAnalysisDetailsCount: {
        id: 'policychange.common.common.premier-risk-analysis.Prior Losses:',
        defaultMessage: 'Claim: { count }'
    },
    removeriskAnalysis: {
        id: 'quoteandbind.views.common.premier.riskanalysis.Remove Risk Analysis?',
        defaultMessage: 'Remove Risk Analysis?',
    },
    removeriskAnalysisDesc: {
        id: 'quoteandbind.views.common.premier.riskanalysis.riskanalysisRemovalMsg',
        defaultMessage: 'Are you sure you want to remove this Risk Analysis from the list?',
    },
    addPriorPolicyBtn: {
        id: 'quoteandbind.views.ppl-risk-analysis.Add New Prior Policy',
        defaultMessage: 'Add New Prior Policy'
    },
    priorPoliciesHeading: {
        id: 'quoteandbind.views.ppl-risk-analysis.Prior Policies',
        defaultMessage: 'Prior Policies'
    },
    type: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Type',
        defaultMessage: 'Type'
    },
    description: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Description',
        defaultMessage: 'Description'
    },
    insuName: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Insurer Name',
        defaultMessage: 'Insurer Name'
    },
    insNamOth: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Other',
        defaultMessage: 'Other'
    },
    plyEfive: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Policy Effective',
        defaultMessage: 'Policy Effective'
    },
    plyExp: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Policy Expiration',
        defaultMessage: 'Policy Expiration'
    },
    retDate: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Retroactive Date',
        defaultMessage: 'Retroactive Date'
    },
    limit: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Limit',
        defaultMessage: 'Limit'
    },
    deductible: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Deductible',
        defaultMessage: 'Deductible'
    },
    premium: {
        id: 'quoteandbind.ppl.views.ppl-risk-analysis.Premium',
        defaultMessage: 'Premium'
    },
    priorPolicyDetailsCount: {
        id: 'policychange.common.common.premier-risk-analysis.Prior Policy:',
        defaultMessage: 'Prior Policy: { count }'
    },
    riskAnalysisDelete: {
        id: 'quoteandbind.views.common.premier.riskanalysis.Delete claim',
        defaultMessage: 'Delete Claim: { count }'
    },
    docFailed: {
        id: 'gateway.directives.riskanalysis.Document Failed',
        defaultMessage: 'Document Failed.'
    },
    printQuoteFailureMsg: {
        id: 'gateway.directives.riskanalysis.Unable to generate and save the print quote document.',
        defaultMessage: 'Unable to generate and save the print quote document.'
    },
    printAppQuoteFailureMsg: {
        id: 'gateway.directives.riskanalysis.Unable to generate and save the print application document.',
        defaultMessage: 'Unable to generate and save the print application document.'
    },
    printAppAndQuoteFailureMsg: {
        id: 'gateway.directives.riskanalysis.Unable to generate and save the print quote and application document.',
        defaultMessage: 'Unable to generate and save the print quote and application document.'
    }
});
